// inspired by: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

const fallbackCopyTextToClipboard = text => {
	var textArea = document.createElement('textarea');
	textArea.value = text;
	textArea.style.position = 'fixed'; //avoid scrolling to bottom
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		document.execCommand('copy');
	} catch (err) {
		// TODO: use prompt as fallback
	}

	document.body.removeChild(textArea);
};

export const copyTextToClipboard = text => {
	if (!navigator.clipboard) {
		fallbackCopyTextToClipboard(text);
		return;
	}

	navigator.clipboard.writeText(text).then(
		() => {},
		() => {
			fallbackCopyTextToClipboard(text);
		}
	);
};
